import { render, staticRenderFns } from "./AddSubsystem.vue?vue&type=template&id=315b1950&scoped=true&"
import script from "./AddSubsystem.vue?vue&type=script&lang=ts&"
export * from "./AddSubsystem.vue?vue&type=script&lang=ts&"
import style0 from "./AddSubsystem.vue?vue&type=style&index=0&id=315b1950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b1950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
